import { TableCell, TableHead, TableRow } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTableHead/CapsulesTableHead.module.scss';

export const CapsulesTableHead: React.FC = () => {
  return (
    <TableHead>
      <TableRow className={styles.headerRow}>
        <TableCell className={classNames(styles.headerCell, styles.nameColumn)}>Name</TableCell>
        <TableCell className={classNames(styles.headerCell, styles.uidColumn)}>
          Dataplane UID
        </TableCell>
        <TableCell className={classNames(styles.headerCell, styles.registeredColumn)}>
          Registered
        </TableCell>
        <TableCell
          aria-label="Actions"
          className={classNames(styles.headerCell, styles.actionsColumn)}
        />
      </TableRow>
    </TableHead>
  );
};
